<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'px-2' : 'px-5'">
    <Snackbar :snackbar="snackbar" :text="text" :timeout="timeout"></Snackbar>

    <!-- dialog pembayaran jasa -->
    <v-dialog
      v-model="dialog.pembayaran_jasa"
      scrollable
      persistent
      width="780"
    >
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Pembayaran jasa</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.pembayaran_jasa = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="color-first title font-weight-bold title mt-7 mb-2">
            Dari rekening
          </div>
          <v-row>
            <v-col cols="12" class="pt-0">
              <div class="background-blue">
                <div>
                  <div>
                    <span>Rekening <b>Bank Mandiri</b></span>
                  </div>
                  <div>
                    <span>No. rekening <b>137-00-0747021-0</b></span>
                  </div>
                  <div>
                    <span
                      ><b
                        >a.n Universitas Islam Indonesia - Lab Farmasi</b
                      ></span
                    >
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <div class="color-first title font-weight-bold title mt-7 mb-2">
            Rekening tujuan
          </div>
          <ValidationObserver ref="observer">
            <v-form>
              <v-row>
                <v-col cols="12" md="12" class="pb-0">
                  <ValidationProvider
                    name="No invoice"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      filled
                      disabled
                      readonly
                      type="text"
                      v-model="form.pembayaran_jasa.no_invoice"
                      label="No. invoice"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Total jasa diterima"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      filled
                      disabled
                      readonly
                      type="text"
                      v-model="form.pembayaran_jasa.total_jasa_diterima"
                      label="Total jasa diterima (Rp)"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Nomor rekening tujuan"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.pembayaran_jasa.nomor_rekening"
                      label="Nomor rekening tujuan"
                      type="number"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Bank"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.pembayaran_jasa.bank"
                      label="Bank tujuan"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Nama pemilik rekening"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.pembayaran_jasa.nama_pemilik_rekening"
                      label="Nama pemilik rekening"
                      outlined
                      dense
                      color="#0299B7"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <v-menu
                    ref="menunow"
                    v-model="form.pembayaran_jasa.item_now"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    class="z-my"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <ValidationProvider
                        name="Tanggal pembayaran"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="form.pembayaran_jasa.tanggal_bayar"
                          label="Tanggal pembayaran"
                          readonly
                          outlined
                          dense
                          color="#0299B7"
                          :error-messages="errors"
                          v-on="on"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="form.pembayaran_jasa.tanggal_bayar"
                      v-on:change="changedate()"
                      color="#0299B7"
                      format="D MMMM YYYY"
                      @input="form.pembayaran_jasa.item_now = false"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider
                    name="Bukti pembayaran"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-file-input
                      v-model="form.pembayaran_jasa.file"
                      label="Bukti pembayaran"
                      outlined
                      dense
                      color="#0299B7"
                      prepend-inner-icon="mdi-attachment"
                      accept=".jpg,.jpeg,.png,.pdf"
                      :rules="[fileSizeRule]"
                      :error-messages="errors"
                      max-size="500KB"
                    >
                    </v-file-input>
                    <i class="mt-1 caption color-second">
                      Maks 2MB dengan format file .pdf
                    </i>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="pb-0 pt-0">
                  <ValidationProvider name="Keterangan">
                    <v-text-field
                      v-model="form.pembayaran_jasa.keterangan"
                      label="Keterangan(Optional)"
                      outlined
                      dense
                      color="#0299B7"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-divider
          style="border-color: #bac0c6; border-radius: 25px"
        ></v-divider>
        <v-card-actions class="mt-2 pb-3 justify-center">
          <v-btn
            outlined
            class="text-capitalize color-first mx-1"
            :disabled="process.form"
            @click="dialog.pembayaran_jasa = false"
          >
            Tutup
          </v-btn>
          <v-btn
            color="#0299B7"
            elevation="0"
            class="text-capitalize white--text mx-1"
            :disabled="process.form"
            @click="cekForm()"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog pembayaran jasa -->

    <!-- dialog ubah -->
    <v-dialog v-model="dialog.ubah" persistent width="650">
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Ubah rekap jasa laboran</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.ubah = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-row>
            <v-col cols="12">
              <table
                width="100%"
                style="
                  font-family: Arial, Helvetica, sans-serif;
                  line-height: 1.7;
                  font-size: 14px;
                "
              >
                <tr>
                  <td width="35%">Nama</td>
                  <td width="3%">:</td>
                  <td>{{ edited.nama || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Laboratorium</td>
                  <td width="3%">:</td>
                  <td>{{ edited.laboratorium || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Jumlah kegiatan</td>
                  <td width="3%">:</td>
                  <td>{{ edited.jumlah_kegiatan || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Masih berlangsung</td>
                  <td width="3%">:</td>
                  <td>{{ edited.masih_berlangsung || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Total nilai transaksi (Rp)</td>
                  <td width="3%">:</td>
                  <td>{{ formatNumber(edited.total_nilai_transaksi) }}</td>
                </tr>
              </table>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
              <v-text-field
                dense
                outlined
                type="number"
                min="0"
                max="100"
                label="Pembagian jasa (%)"
                color="#0299B7"
                v-model="edited.pembagian_jasa"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
              <v-text-field
                dense
                outlined
                label="No invoice"
                color="#0299B7"
                v-model="edited.no_invoice"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <v-select
                dense
                outlined
                :items="list.status_edit"
                item-text="nama"
                item-value="id"
                label="Status"
                color="#0299B7"
                v-model="edited.status"
              >
                <template v-slot:append>
                  <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" class="pt-0">
              <table
                width="100%"
                style="
                  font-family: Arial, Helvetica, sans-serif;
                  line-height: 1.7;
                  font-size: 14px;
                "
              >
                <tr>
                  <td width="35%">Total jasa diterima (Rp)</td>
                  <td width="3%">:</td>
                  <td>
                    <b>{{ totalJasaTerhitung }}</b>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider
          style="border-color: #bac0c6; border-radius: 25px"
        ></v-divider>
        <v-card-actions class="mt-2 pb-3 justify-center">
          <v-btn
            outlined
            class="text-capitalize color-first mx-1"
            :disabled="process.run"
            @click="dialog.ubah = false"
          >
            Tutup
          </v-btn>
          <v-btn
            color="#0299B7"
            elevation="0"
            class="text-capitalize white--text mx-1"
            :disabled="process.run"
            @click="save_type = 'ubah_rekap'; dialog.konfirmasi = true"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog ubah -->

    <!-- dialog konfirmasi -->
    <v-dialog v-model="dialog.konfirmasi" persistent width="450">
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Konfirmasi</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.konfirmasi = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5 text-center mt-2">
          <span class="font-weight-bold title">
            Simpan data yang diinputkan ?
          </span>
          <v-card-subtitle class="pt-0">
            <span class="body-2">Pastikan data sudah sesuai</span>
          </v-card-subtitle>
        </v-card-text>
        <v-divider
          style="border-color: #bac0c6; border-radius: 25px"
        ></v-divider>
        <v-card-actions class="mt-2 pb-3 justify-center">
          <v-btn
            outlined
            class="text-capitalize color-first mx-1"
            :disabled="process.run"
            @click="dialog.konfirmasi = false"
          >
            Batal
          </v-btn>
          <v-btn
            color="#0299B7"
            elevation="0"
            class="text-capitalize white--text mx-1"
            :loading="process.run"
            :disabled="process.run"
            @click="save"
          >
            Ya, simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog konfirmasi -->

    <!-- dialog download -->
    <v-dialog v-model="dialog.download" scrollable persistent width="400">
      <v-card flat>
        <v-card-text class="text-center">
          <p class="mb-0 mt-3">Proses menyiapkan preview PDF....</p>
          <div class="mt-2">
            <v-progress-linear color="#0299B7" indeterminate rounded height="6">
            </v-progress-linear>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog download -->

    <LoadingComponent v-if="process.loading"></LoadingComponent>

    <v-row
      class="mt-3"
      :class="$vuetify.breakpoint.name !== 'xs' ? 'px-3' : 'pr-0 pl-3'"
      v-if="!process.loading"
    >
      <v-col cols="12">
        <v-card class="border-radius box-shadow pa-1">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-card-text>
                <div class="color-first title font-weight-bold title mt-3">
                  Rekap Jasa Laboran
                </div>

                <!-- row filter -->
                <v-row class="pt-5">
                  <v-col cols="12" md="3">
                    <v-menu
                      v-model="filter.menu_start"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          dense
                          outlined
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          label="Periode awal pembayaran jasa"
                          color="#0299B7"
                          :value="formatDate(filter.start_date)"
                          hide-details
                        >
                          <template v-slot:append>
                            <v-icon color="#7B7B7B">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        color="#0299B7"
                        v-model="filter.start_date"
                        @input="
                          filter.menu_start = false;
                          getList();
                        "
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu
                      v-model="filter.menu_end"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          dense
                          outlined
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          label="Periode akhir pembayaran jasa"
                          color="#0299B7"
                          :value="formatDate(filter.end_date)"
                          hide-details
                        >
                          <template v-slot:append>
                            <v-icon color="#7B7B7B">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        color="#0299B7"
                        v-model="filter.end_date"
                        :min="filter.start_date"
                        @input="
                          filter.menu_end = false;
                          getList();
                        "
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      dense
                      :disabled="process.run"
                      outlined
                      :items="list.lab"
                      item-text="nama_laboratorium"
                      item-value="id"
                      v-model="filter.lab"
                      v-on:change="getList()"
                      label="Laboratorium"
                      color="#0299B7"
                      hide-details
                    >
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      dense
                      :disabled="process.run"
                      outlined
                      :items="list.status"
                      item-text="nama"
                      item-value="id"
                      v-model="filter.status"
                      v-on:change="getList()"
                      label="Status"
                      color="#0299B7"
                      hide-details
                    >
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <!-- end row filter -->

                <!-- infobox -->
                <v-row class="mt-5">
                  <v-col cols="12">
                    <div
                      class="pa-4 d-flex align-center"
                      style="background-color: #f2fafe; border-radius: 8px"
                    >
                      <v-icon color="#0077BB" class="mr-3"
                        >mdi-information</v-icon
                      >
                      <span class="body-2">
                        <b>Masih berlangsung</b> adalah kegiatan laboran
                        (penelitian, pengujian, dsb) sedang berlangsung, potensi
                        jasa (Rp) yang didapat belum bisa ditransfer karena
                        kegiatan belum selesai
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <!-- end infobox -->

                <!-- row table -->
                <v-card-text
                  class="pa-5 px-0"
                  style="height: calc(100vh - 330px)"
                >
                  <v-skeleton-loader
                    :loading="process.run"
                    transition="scale-transition"
                    :tile="false"
                    :style="process.run ? 'height: calc(100vh - 400px)' : ''"
                    type="table-tbody"
                  >
                    <v-data-table
                      :headers="headers"
                      :items="rows"
                      :items-per-page="10"
                      class="elevation-1 required rekap-table"
                    >
                      <template v-slot:[`item.status`]="{ item }">
                        <td>
                          <span :class="getStatusClass(item.status)">{{
                            item.status
                          }}</span>
                        </td>
                      </template>
                      <template v-slot:[`item.aksi`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="30"
                              color="orange"
                              :disabled="process.run"
                              @click="editForm(item)"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Ubah</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="25"
                              color="#0299B7"
                              :disabled="process.run"
                              @click="printForm(item)"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <div
                                class="d-flex align-center text-capitalize body-2"
                              >
                                <img
                                  :src="
                                    require('@/assets/image/download_pdf.png')
                                  "
                                  alt=""
                                />
                              </div>
                            </v-btn>
                          </template>
                          <span>Print PDF</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="25"
                              color="#0299B7"
                              :disabled="process.run"
                              @click="detailForm(item)"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>Pembayaran jasa</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-skeleton-loader>
                </v-card-text>
                <!-- end row table -->

                <!-- pdf -->
                <div>
                  <vue-html2pdf
                    :show-layout="false"
                    :float-layout="true"
                    :enable-download="false"
                    :preview-modal="true"
                    :paginate-elements-by-height="1400"
                    :filename="print_filename"
                    :pdf-quality="2"
                    :manual-pagination="false"
                    pdf-format="a4"
                    :pdf-margin="10"
                    pdf-orientation="portrait"
                    pdf-content-width="800px"
                    ref="html2Pdf"
                  >
                    <section slot="pdf-content">
                      <Pdf parameter="jasa-laboran" ref="pdf" v-model="files" />
                    </section>
                  </vue-html2pdf>
                </div>
                <!-- end pdf -->
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
const { VUE_APP_API_URL } = process.env;
import moment from "moment";
import "moment/locale/id";
import { get, put } from "@/service/Axios";
import { serialize } from "object-to-formdata";
import statusMixin from "@/mixin";
import Snackbar from "@/components/Snackbar.vue";
import LoadingComponent from "@/components/Loading.vue";
import Pdf from "@/components/Pdf.vue";

// const endpoint = "laboran-fee-recap";
const endpoint = "research-recap";

export default {
  mixins: [statusMixin],
  data() {
    return {
      dialog: {
        pembayaran_jasa: false,
        ubah: false,
        konfirmasi: false,
        download: false
      },
      detailUuid: "",
      detail: {},
      edited: {},
      form: {
        pembayaran_jasa: {
          uuid: "",
          no_invoice: "",
          item_now: false,
          tanggal_bayar: "",
          total_jasa_diterima: "",
          nomor_rekening: "",
          bank: "",
          nama_pemilik_rekening: "",
          file: null,
          keterangan: ""
        }
      },
      fileSizeRule: (value) => {
        if (!value) {
          return true;
        }
        const size = value.size / 1024 / 1024; // konversi byte ke megabyte
        return size <= 500 ? true : "Ukuran file tidak boleh lebih dari 500KB";
      },
      filter: {
        lab: "all",
        status: "all",
        start_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        menu_start: false,
        menu_end: false
      },
      process: {
        run: false,
        loading: false
      },
      list: {
        lab: [],
        status: [
          { id: "all", nama: "Semua" },
          { id: "Belum bayar", nama: "Belum bayar" },
          { id: "Terbayar lunas", nama: "Terbayar lunas" }
        ],
        status_edit: [
          { id: "Belum bayar", nama: "Belum bayar" },
          { id: "Terbayar lunas", nama: "Terbayar lunas" }
        ]
      },
      rows: [],
      headers: [
        { text: "No.", value: "no", sortable: false },
        {
          text: "Jenis penggunaan",
          value: "jenis_penggunaan",
          sortable: false
        },
        { text: "Nama", value: "nama", sortable: false },
        { text: "Laboratorium", value: "laboratorium", sortable: false },
        { text: "Jumlah kegiatan", value: "jumlah_kegiatan", sortable: false },
        {
          text: "Masih berlangsung",
          value: "masih_berlangsung",
          sortable: false
        },
        {
          text: "Total nilai transaksi (Rp)",
          value: "total_nilai_transaksi",
          align: "right",
          sortable: false
        },
        {
          text: "Pembagian jasa (%)",
          value: "pembagian_jasa",
          sortable: false
        },
        {
          text: "Total jasa diterima",
          value: "total_jasa_diterima",
          align: "right",
          sortable: false
        },
        { text: "No invoice", value: "no_invoice", sortable: false },
        { text: "Status", value: "status", sortable: false, width: "9%" },
        { text: "Aksi", value: "aksi", align: "center", width: "12%" }
      ],
      files: null,
      print_filename: "rekap-jasa-laboran",
      save_type: "",
      snackbar: false,
      text: "",
      timeout: 3000
    };
  },
  components: {
    Snackbar,
    LoadingComponent,
    Pdf
  },
  watch: {
    files: {
      handler: function () {
        this.dialog.download = this.files.add;
      },
      deep: true
    }
  },
  computed: {
    reminder() {
      let now = new Date(),
        next = new Date(now);
      next.setDate(now.getDate());
      return next.toISOString().substr(0, 10);
    },
    token() {
      return this.$store.state.access_token;
    },
    totalJasaTerhitung() {
      const nilai = Number(this.edited.total_nilai_transaksi) || 0;
      const persen = Number(this.edited.pembagian_jasa) || 0;
      return ((nilai * persen) / 100).toLocaleString("id-ID");
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.process.loading = true;
      await this.getLaboratory();
      await this.getList();
      this.process.loading = false;
    },

    async getLaboratory() {
      try {
        const params = { flag_lainnya: "1" };
        const { data, status } = await get("laboratory-master", { params });
        if (status === 200 && data.data) {
          const lab = data.data.map((item) => ({
            id: item.id,
            nama_laboratorium: item.namaLaboratorium
          }));
          lab.unshift({ id: "all", nama_laboratorium: "Semua" });
          this.list.lab = lab;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getList() {
      try {
        this.process.run = true;
        const params = {
          id_laboratorium: this.filter.lab,
          tgl_pembayaran_awal: this.filter.start_date,
          tgl_pembayaran_akhir: this.filter.end_date,
          status: this.filter.status
        };
        const { data, status } = await get(endpoint, { params });
        if (status === 200 && data.data) {
          this.rows = data.data.map((item, index) => this.mapRow(item, index));
        }
      } catch (error) {
        console.log(error);
        this.rows = [];
      } finally {
        this.process.run = false;
      }
    },

    mapRow(item, index) {
      return {
        no: index + 1,
        jenis_penggunaan: item.jenisPenggunaan || "-",
        nama: item.nama || "-",
        laboratorium: item.namaLaboratorium || "-",
        jumlah_kegiatan:
          item.jumlahKegiatan !== undefined ? item.jumlahKegiatan : "-",
        masih_berlangsung:
          item.masihBerlangsung !== undefined ? item.masihBerlangsung : "-",
        total_nilai_transaksi: this.formatNumber(item.totalNilaiTransaksi),
        pembagian_jasa:
          item.pembagianJasa !== undefined ? item.pembagianJasa : "-",
        total_jasa_diterima: this.formatNumber(item.totalJasaDiterima),
        no_invoice: item.noInvoice || "-",
        status: item.status || "-",
        total_nilai_transaksi_raw: item.totalNilaiTransaksi,
        raw: item
      };
    },

    editForm(item) {
      this.edited = {
        uuid: item.uuid || "",
        nama: item.nama,
        laboratorium: item.laboratorium,
        jenis_penggunaan: item.jenis_penggunaan,
        jumlah_kegiatan: item.jumlah_kegiatan,
        masih_berlangsung: item.masih_berlangsung,
        total_nilai_transaksi:
          Number(item.total_nilai_transaksi_raw) ||
          Number(String(item.total_nilai_transaksi || "").replace(/\./g, "")) ||
          0,
        pembagian_jasa: item.pembagian_jasa,
        no_invoice: item.no_invoice === "-" ? "" : item.no_invoice,
        status: item.status
      };
      this.dialog.ubah = true;
    },

    detailForm(item) {
      const { form } = this;
      this.detailUuid = item.uuid || "";
      form.pembayaran_jasa.uuid = item.uuid || "";
      form.pembayaran_jasa.no_invoice = item.no_invoice;
      form.pembayaran_jasa.total_jasa_diterima = item.total_jasa_diterima;
      form.pembayaran_jasa.nomor_rekening =
        item.raw && item.raw.noRekeningTujuan ? item.raw.noRekeningTujuan : "";
      form.pembayaran_jasa.bank =
        item.raw && item.raw.namaBankTujuan ? item.raw.namaBankTujuan : "";
      form.pembayaran_jasa.nama_pemilik_rekening =
        item.raw && item.raw.namaPemilikRekeningTujuan
          ? item.raw.namaPemilikRekeningTujuan
          : "";
      form.pembayaran_jasa.tanggal_bayar = "";
      form.pembayaran_jasa.file = null;
      form.pembayaran_jasa.keterangan = "";
      this.dialog.pembayaran_jasa = true;
    },

    printForm(item) {
      this.dialog.download = true;
      this.print_filename = `rekap-jasa-laboran-${(item.nama || "")
        .toLowerCase()
        .replace(/\s+/g, "-")}`;
      const payload = {
        jenisPenggunaan: item.jenis_penggunaan,
        nama: item.nama,
        namaLaboratorium: item.laboratorium,
        jumlahKegiatan: item.jumlah_kegiatan,
        masihBerlangsung: item.masih_berlangsung,
        totalNilaiTransaksi: Number(item.total_nilai_transaksi_raw) || 0,
        pembagianJasa: item.pembagian_jasa,
        totalJasaDiterima:
          Number(String(item.total_jasa_diterima || "").replace(/\./g, "")) ||
          0,
        noInvoice: item.no_invoice,
        status: item.status,
        periodeAwal: this.formatDate(this.filter.start_date),
        periodeAkhir: this.formatDate(this.filter.end_date)
      };
      this.$store.dispatch("getDataPdf", payload);
      this.$refs.pdf.downloadPdf(item, this.$refs.html2Pdf);
    },

    async cekForm() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.save_type = "pembayaran_jasa";
        this.dialog.konfirmasi = true;
      }
    },

    async save() {
      switch (this.save_type) {
        case "pembayaran_jasa":
          this.savePembayaranJasa();
          break;
        case "ubah_rekap":
          this.saveUbah();
          break;
        default:
      }
    },

    async savePembayaranJasa() {
      this.process.form = true;
      const { token, form } = this;
      const value = {
        uuid: form.pembayaran_jasa.uuid,
        tgl_pembayaran: form.pembayaran_jasa.tanggal_bayar,
        no_rekening_tujuan: form.pembayaran_jasa.nomor_rekening,
        nama_bank_tujuan: form.pembayaran_jasa.bank,
        nama_pemilik_rekening_tujuan:
          form.pembayaran_jasa.nama_pemilik_rekening,
        file_bukti_pembayaran: form.pembayaran_jasa.file,
        keterangan: form.pembayaran_jasa.keterangan
      };

      const options = {
        indices: true,
        nullsAsUndefineds: false,
        booleansAsIntegers: false,
        allowEmptyArrays: false,
        noFilesWithArrayNotation: false,
        dotsForObjectNotation: false
      };

      const formData = serialize(value, options);

      const authHeader = new Headers({ Authorization: `Bearer ${token}` });

      const config = { method: "POST", headers: authHeader, body: formData };

      const response = await fetch(`${VUE_APP_API_URL}${endpoint}/pay`, config);
      if (response.status === 201) {
        this.dialog.konfirmasi = false;
        this.dialog.pembayaran_jasa = false;
        this.text = "Data pembayaran jasa laboran berhasil disimpan";
        this.snackbar = true;
        this.process.form = false;
        this.getList();
        this.$refs.observer.reset();
      } else {
        this.dialog.konfirmasi = false;
        this.process.form = false;
      }
    },

    async saveUbah() {
      try {
        this.process.run = true;
        const params = {
          uuid: this.edited.uuid,
          pembagian_jasa: this.edited.pembagian_jasa,
          no_invoice: this.edited.no_invoice,
          status: this.edited.status
        };
        const response = await put(endpoint, { params });
        if (response.status === 200) {
          this.dialog.konfirmasi = false;
          this.dialog.ubah = false;
          this.text = "Data rekap jasa laboran berhasil diupdate";
          this.snackbar = true;
          this.getList();
        } else {
          this.dialog.konfirmasi = false;
          this.dialog.ubah = false;
        }
      } catch (error) {
        console.log(error);
        this.dialog.konfirmasi = false;
        this.dialog.ubah = false;
      } finally {
        this.process.run = false;
      }
    },

    formatDate(value) {
      return value ? moment(value).locale("id").format("DD MMMM YYYY") : "-";
    },

    changedate() {
      this.form.pembayaran_jasa.tanggal_bayar = this.reminder;
    },

    formatNumber(value) {
      if (value === undefined || value === null || value === "") {
        return "-";
      }
      const number = Number(value);
      return Number.isNaN(number) ? value : number.toLocaleString("id-ID");
    }
  }
};
</script>

<style scoped>
.rekap-table {
  white-space: nowrap;
}

.rekap-table >>> th,
.rekap-table >>> td {
  white-space: nowrap;
}

.rekap-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}
</style>
